import { CellFn } from "@/graphHandling/graphTypes";

export const update_mainProcess: CellFn = storeFunctions => {
  storeFunctions.updateGraph(["custom"], {
    updatedAt: new Date()
  });
  return true;
};
